module.exports = __webpack_public_path__ + "static/scale-model-of-georgia-museum-of-natural-history-in-athens-georgia-029d3e8bb1d9c713738a6ffebbedbe65.png";